"use cleint";

import { useMediaQuery, useTheme } from "@mui/material";

export function useBreakPoints() {
  const theme = useTheme();

  const xsAndDown = useMediaQuery(theme.breakpoints.down("xs"));
  const xsAndUp = useMediaQuery(theme.breakpoints.up("xs"));
  const xs = useMediaQuery(theme.breakpoints.only("xs"));

  const xsmAndDown = useMediaQuery(theme.breakpoints.down("xsm"));
  const xsmAndUp = useMediaQuery(theme.breakpoints.up("xsm"));
  const xsm = useMediaQuery(theme.breakpoints.only("xsm"));

  const smAndDown = useMediaQuery(theme.breakpoints.down("sm"));
  const smAndUp = useMediaQuery(theme.breakpoints.up("sm"));
  const sm = useMediaQuery(theme.breakpoints.only("sm"));

  const mdAndDown = useMediaQuery(theme.breakpoints.down("md"));
  const mdAndUp = useMediaQuery(theme.breakpoints.up("md"));
  const md = useMediaQuery(theme.breakpoints.only("md"));

  const lgAndDown = useMediaQuery(theme.breakpoints.down("lg"));
  const lgAndUp = useMediaQuery(theme.breakpoints.up("lg"));
  const lg = useMediaQuery(theme.breakpoints.only("lg"));

  const xlAndDown = useMediaQuery(theme.breakpoints.down("xl"));
  const xlAndUp = useMediaQuery(theme.breakpoints.up("xl"));
  const xl = useMediaQuery(theme.breakpoints.only("xl"));
  return {
    xsAndDown,
    xsAndUp,
    xs,
    smAndDown,
    smAndUp,
    sm,
    mdAndDown,
    mdAndUp,
    md,
    lgAndDown,
    lgAndUp,
    lg,
    xlAndDown,
    xlAndUp,
    xl,
    xsmAndDown,
    xsmAndUp,
    xsm,
  };
}
